import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, makeObservable, observable, runInAction } from "mobx";
class TcfVendor {
    data;
    /**
     * Get existing vendor configuration for this vendor.
     */ get vendorConfiguration() {
        for (const c of this.store.vendorConfigurations.entries.values()){
            if (c.vendorModel?.data.id === this.data.id) {
                return c;
            }
        }
        return undefined;
    }
    /**
     * Calculate a map of restrictions for this vendor. This can be used to make a form
     * configurable depending on the current vendor.
     */ get restrictivePurposes() {
        const result = {
            normal: {}
        };
        for (const purpose of [
            ...this.legIntPurposes,
            ...this.purposes
        ]){
            result.normal[purpose.data.id.toString()] = {
                enabled: true,
                legInt: this.legIntPurposes.indexOf(purpose) > -1 && !purpose.special ? "yes" : "no"
            };
        }
        return result;
    }
    /**
     * Map the integers to valid declaration objects.
     */ get purposes() {
        return this.data?.purposes.map((id)=>this.store.purposes.get(`${id}`));
    }
    get legIntPurposes() {
        return this.data?.legIntPurposes.map((id)=>this.store.purposes.get(`${id}`));
    }
    get specialPurposes() {
        return this.data?.specialPurposes.map((id)=>this.store.specialPurposes.get(`${id}`));
    }
    get features() {
        return this.data?.features.map((id)=>this.store.features.get(`${id}`));
    }
    get specialFeatures() {
        return this.data?.specialFeatures.map((id)=>this.store.specialFeatures.get(`${id}`));
    }
    get dataCategories() {
        return this.data?.dataDeclaration.map((id)=>this.store.dataCategories.get(`${id}`));
    }
    store;
    constructor(data, store){
        makeObservable(this);
        runInAction(()=>{
            this.data = data;
        });
        this.store = store;
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], TcfVendor.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], TcfVendor.prototype, "vendorConfiguration", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], TcfVendor.prototype, "restrictivePurposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], TcfVendor.prototype, "purposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], TcfVendor.prototype, "legIntPurposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], TcfVendor.prototype, "specialPurposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], TcfVendor.prototype, "features", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], TcfVendor.prototype, "specialFeatures", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], TcfVendor.prototype, "dataCategories", null);
export { TcfVendor };
